import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { EmailPreferences } from 'apps/profile/settings/tabs/notifications/emailPreferences/index';

@inject('routerStore')
@observer
export class NotificationSettings extends React.Component {
  render() {
    return (
      <React.Fragment>
        <EmailPreferences />
      </React.Fragment>
    );
  }
}

NotificationSettings.propTypes = {
  routerStore: PropTypes.object,
};
